import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // No changes needed in this CSS file
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

// If you have a logo, you can import it here
// import logo from '../../Assets/logo-white.png'; 

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        {/* Column 1: Brand Info */}
        <div className="footer-col footer-brand">
          <Link to="/" className="footer-logo">
            {/* <img src={logo} alt="InvestInISB Logo" /> */}
            <h3 className="footer-logo-text" style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>InvestInISB</h3>
          </Link>
          <h4>Invest Smart. Invest Safe. Invest in Islamabad.</h4>
          <p>
            Your trusted partner in navigating the dynamic real estate market of Islamabad. We provide expert guidance and exclusive access to premium properties.
          </p>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            {/* <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a> */}
            {/* <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a> */}
          </div>
        </div>

        {/* Column 2: Quick Links (Updated) */}
        <div className="footer-col footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-islamabad">About Islamabad</Link></li>
            <li><Link to="/blue-world-city">Blue World City</Link></li>
            <li><Link to="/investment-opportunities">Investment Guide</Link></li>
            <li><Link to="/sectors-overview">Sectors Overview</Link></li>
            {/* <li><Link to="/blog">Insights</Link></li> */}
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Column 3: Key Topics (Updated from "Featured Projects") */}
        <div className="footer-col footer-projects">
          <h3>Key Topics</h3>
          <ul>
            <li><Link to="/future-growth">Future Growth Regions</Link></li>
            <li><Link to="/airport-societies">Airport Societies</Link></li>
            <li><Link to="/private-societies">Private Societies</Link></li>
            <li><Link to="/housing-schemes-status">Housing Scheme Status</Link></li>
            <li><Link to="/residential-areas">Residential Areas</Link></li>
            <li><Link to="/why-invest">Why to Invest</Link></li>
          </ul>
        </div>
        
        {/* Column 4: Contact Info */}
        <div className="footer-col footer-contact">
          <h3>Contact Info</h3>
          <p><FiMapPin />Plot no 2 near kiayani house opposite attock petrol pump DHA 2 GT road Islamabad</p>
          <p><FiPhone />0333-111-111-4</p>
          <p><FiMail />zemaydar.net@gmail.com</p>
          <Link to="/contact" className="footer-cta-btn">
            Book Free Consultation
          </Link>
        </div>
        
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} All rights reserved Zemaydar ventures.</p>
        {/* <p>Designed by <a href="https://your-company.com" target="_blank" rel="noopener noreferrer">Your Company</a></p> */}
      </div>
    </footer>
  );
}

export default Footer;